module.exports = __webpack_public_path__ + "static/media/benefit_3.cd640329.jpg";